import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-htmlcontentimmudb',
  templateUrl: './htmlcontentimmudb.component.html',
  styleUrls: ['./htmlcontentimmudb.component.scss']
})
export class HtmlcontentimmudbComponent implements OnInit {
  @Input() item: any
  htmlContent: string | null = null;
  blobUrl: string | null = null;
  safeurl: any;
  showLoader: boolean = false
  constructor(private _snackBar: MatSnackBar, private router: Router, private commonServ: CommonService, private http: HttpClient, private sanitizer: DomSanitizer, private modalService: NgbModal, public dialog: MatDialog) { }

  ngOnInit(): void {

    console.log(this.item)
    this.viewdatainhtmlpage(this.item)
  }

  downloaddata() {
    this.showLoader = true
    console.log(this.item)
    this.commonServ.downloadpdffile(this.item['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      const filename = this.item['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
      this.showLoader = false;
    })
  }

  downloaddata2() {
    console.log(this.item)
    this.showLoader = true
    this.commonServ.downloadpdffile2(this.item['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = this.item['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
      this.showLoader = false
    })
  }

  viewdatainhtmlpage(n) {
    this.commonServ.downloadpdffile(n['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = n['doc_name'];
      var url = this.commonServ.fetchAndDisplayBlob(response[0].doc_contenet, filename);
      console.log("url", url)
      this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
        this.blobUrl = URL.createObjectURL(blob);
        this.safeurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl)
        // this.modalService.open(this.popupview, { size: 'lg' });
      });
    })
  }

}
